import { ImageMetaMapType } from './meta.types';

export const IMAGE_META_MAP: ImageMetaMapType = {
  en: {
    default: 'en-default-meta',
    fot: 'en-fot-meta',
    museums: 'en-museums-meta',
    pygx: 'en-pygx-meta',
    tdi: 'en-tdi-meta',
    vq: 'en-vq-meta',
  },
  it: {
    museums: 'it-museums-meta',
  },
};
